import React, { useEffect, useState } from "react";
import classNames from "classnames";

import { dateFormat, timeFormat } from "utils/format";
import { ROUTES } from "features/Users/Addresses";
import { setPrintedAssemblyList } from "services/api";

import "./printAssemblyList.scss";
import Barcode from "react-barcode";


export const PrintAssemblyList = ({ order, setShowPrintAssembliList, setLoading, callback, products }) => {

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 200);
    setTimeout(() => {
      setShowPrintAssembliList(false);
    }, 200);

    window.addEventListener('afterprint', function () {

      setLoading(true);
      setPrintedAssemblyList({
        id: order.id,
      })
        .then((res) => {
          if (callback) {
            callback(res);
          }
        })
        .finally(() => {
          setLoading(false);
        });

    });
  }, []);

  const providerRender = (product) => {

    const provAdd = [];
    if (product.providersStock?.length > 0) {
      for (const prov of product.providersStock) {
        if (prov.id !== product.provider.id) {
          if (!provAdd.find(v => v === prov.name)) {
            provAdd.push(prov.name);
          }
        }
      }
    }

    return product.provider.name + (provAdd.length > 0 ? ` (${provAdd.join(', ')})` : "");
  }

  const stockRender = (product) => {

    if (product.inStockAll && product.inStockAll !== product.inStock) {
      return product.inStock + ` (${product.inStockAll})`
    }

    return product.inStock;
  }

  const getCellName = (product) => {
    const cell = product.nomenclature?.cell;
    return typeof cell === "string" ? cell : (cell?.name ?? "");
  };

  const sortByCellName = (a, b) =>
    getCellName(a).localeCompare(getCellName(b), undefined, { sensitivity: "base" });

  const getSortByCell = (product) => product.nomenclature?.sortByCell ?? 0;
  const hasCell = (product) => getCellName(product).trim() !== "";

  const sorted = (products) => {
    const withZeroSort = products.filter((p) => getSortByCell(p) === 0);
    const withNonZeroSort = products.filter((p) => getSortByCell(p) > 0);
    const withCell = withZeroSort.filter(hasCell);
    const withoutCell = withZeroSort.filter((p) => !hasCell(p));

    const bySortAsc = (a, b) => getSortByCell(a) - getSortByCell(b);
    const groupSort0ByName = [...withCell].sort(sortByCellName);
    const groupSort0NoCell = withoutCell;
    const groupSortNonZero = [...withNonZeroSort].sort(bySortAsc);

    return [...groupSort0ByName, ...groupSortNonZero, ...groupSort0NoCell];
  };

  return (
    <>
      <style>
        {`@media print {
            @page {
              size: A4 landscape;
              margin: 0;
				    }}
          }`
        }
      </style>

      <div className={classNames("printAssemblyList")}>
        <div className="infoBlock">
          <div className="leftBlock">
            <div className="number">
              Заказ № {order.number} от {dateFormat(order.date)}{' '}
              <span className="time">{timeFormat(order.date)}</span>
            </div>

            <div className="headItem">
              <div className="headItem__title">Клиент</div>
              {order.customer.name}
            </div>

            <div className="headItem">
              <div className="headItem__title">Город доставки</div>
              {order.address?.city}
            </div>          
            <div className="headItem">
              <div className="headItem__title">Адрес доставки</div>
              {order.address?.address}
            </div>

            {order.delivery?.id === 3 &&
              <div className="headItem transport">
                <div className="headItem__title">Транспортная компания</div>
                {order.address?.transportCompany}
              </div>
            }

            <div className="headItem">
              <div className="headItem__title">Комментарий к заказу</div>
              {order.comment}
            </div>

            <div className="headItem route">
              <div className="headItem__title">Маршрут доставки</div>
              {ROUTES.find(v => v.value === order.route)?.shortName}
            </div>

            <div className="headItem">
              <div className="headItem__title">Менеджер</div>
              {order.admin.name}
            </div>
          </div>
          <div className="rightBlock">
            <Barcode height={40} fontSize={20} value={`O${order?.number}`} format="CODE128" />
          </div>
        </div>


        <table>
          <thead>
            <tr>
              <th>п/н</th>
              <th>Поставщик</th>
              <th>Наименование</th>
              <th>Бренд</th>
              <th>Артикул</th>
              <th>Ячейка</th>
              <th>Кол-во</th>
              <th>Поступление</th>
              <th>Комментарий</th>
            </tr>
          </thead>
          <tbody>
            {sorted(products).map((product, i) =>
              <tr
                className={
                  classNames(
                    { "red-bg": product.reserveProduct !== product.count && product.inStock < product.count }
                  )
                }
                key={product.id}
              >
                <td>{i + 1}</td>
                <td>
                  {providerRender(product)}
                </td>
                <td>{product.nomenclature.name}</td>
                <td>{product.nomenclature.brand}</td>
                <td>{product.nomenclature.article}</td>
                <td className="nowrap">{product.nomenclature.cell}</td>
                <td>{product.count}</td>
                <td dangerouslySetInnerHTML={{
                  __html: Array.from(product.batch?.map(v => v.document) || []).join('<br>')
                }} />
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
        <br />
        <br />
        <div className="bottom">
          <p>Всего мест: {order.settings.quantityLabels}</p>
          <p>Паллет: {order.settings.quantityPallets}</p>
          <p>Выполнил: ____________________________________________</p>
        </div>
      </div >
    </>
  );
};